import _ from "lodash";
import React from "react";
import { useIntl } from "react-intl";

export const TextArrayValues = (props) => {
  const { values = [], changeValues } = props;
  const intl = useIntl();
  const format = "HH:mm";
  return (
    <div>
      {_.map(values, (value, index) => {
        return (
          <div className="row mb-1" key={index}>
            <div className="col-10">
              <textarea
                onChange={({ target }) => {
                  values[index] = target.value;
                  changeValues(values);
                }}
                className="form-control"
              >
                {value}
              </textarea>
            </div>

            <div className="col text-right">
              <TextArrayValues.RemoveButton {...props} index={index} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

TextArrayValues.AddButton = (props) => {
  const { values = [], changeValues } = props;
  const addValue = () => {
    changeValues(values.concat([""]));
  };
  return (
    <button className={`btn btn-success ${props.className}`} onClick={addValue}>
      <i className="fa fa-plus" />
    </button>
  );
};

TextArrayValues.RemoveButton = (props) => {
  const { values = [], changeValues } = props;
  const removeValue = () => {
    changeValues(values.filter((elem, index) => index !== props.index));
  };
  return (
    <button className={`btn btn-sm btn-danger`} onClick={removeValue}>
      <i className="fa fa-minus" />
    </button>
  );
};

export default TextArrayValues;
